import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import buttonsSelectorsEN from './locales/en/buttonsSelectors.json';
import errorsEN from './locales/en/errors.json';
import feesEN from './locales/en/fees.json';
import feesPayPageEN from './locales/en/feesPayPage.json';

import buttonsSelectorsFR from './locales/fr/buttonsSelectors.json';
import errorsFR from './locales/fr/errors.json';
import feesFR from './locales/fr/fees.json';

export const resources = {
  en: {
    buttonsSelectors: buttonsSelectorsEN,
    errors: errorsEN,
    fees: feesEN,
    feesPayPage: feesPayPageEN,
  },
  fr: {
    buttonsSelectors: buttonsSelectorsFR,
    errors: errorsFR,
    fees: feesFR,
    feesPayPage: feesPayPageEN,
  },
} as const;

export type Resources = typeof resources;

i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en', // fallback if translation is absent
  ns: ['buttonsSelectors', 'errors', 'fees', 'feesPayPage'],
  defaultNS: 'staticContent',
  resources,
});

export default i18n;
